import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../hooks/useAuth';
import { createLogger } from '../utils/logger';

const log = createLogger('Login');

export const Login: React.FC = () => {
  const { login, logout, isAuthenticated, authBypassActive } = useAuth();

  if (isAuthenticated) {
    if (authBypassActive) {
      // The "Dev bypass" indicator is rendered in the sidebar footer (see AppShell).
      return null;
    }
    return (
      <button
        onClick={() => {
          log.info('User logged out');
          logout();
        }}
        className="px-3 py-1.5 text-sm font-medium text-slate-700 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-all duration-200"
      >
        Logout
      </button>
    );
  }

  return (
    <GoogleLogin
      onSuccess={(credentialResponse) => {
        if (credentialResponse.credential) {
          log.info('Google login successful');
          login(credentialResponse.credential);
        }
      }}
      onError={() => {
        log.error('Google login failed');
      }}
      useOneTap
    />
  );
};
